__turbopack_context__.v({
  "caret": "showmore-module-scss-module__PHpT6W__caret",
  "contentShowText": "showmore-module-scss-module__PHpT6W__contentShowText",
  "contentShowWrapper": "showmore-module-scss-module__PHpT6W__contentShowWrapper",
  "contentShown": "showmore-module-scss-module__PHpT6W__contentShown",
  "contentWrapper": "showmore-module-scss-module__PHpT6W__contentWrapper",
  "dropdownIcon": "showmore-module-scss-module__PHpT6W__dropdownIcon",
  "hidden": "showmore-module-scss-module__PHpT6W__hidden",
  "show": "showmore-module-scss-module__PHpT6W__show",
  "textTop": "showmore-module-scss-module__PHpT6W__textTop",
  "wrapper": "showmore-module-scss-module__PHpT6W__wrapper",
});
